/* PIP sticky koopknop (fase 2, groep 16, 29-09-2026). Geladen vanuit snippets/pip-sticky-atc.liquid (alleen de productpagina).
   - De balk verschijnt zodra de gewone koopknop boven uit beeld is gescrold, en verdwijnt als die weer in beeld komt.
   - Toevoegen gaat altijd via een klik op de gewone koopknop, zodat de maatcontrole, de melding 'Toegevoegd aan winkelmandje',
     pre-orders en apps precies zo werken als bij die knop.
   - Nog geen maat gekozen: de maatlijst opent via window.pipMk.open (assets/pip-maatkiezer.js): mobiel de lade, desktop een
     lijst die boven het maatveld in de balk uitrolt (29-09, 15:30 op verzoek; eerst een popup in het midden). Kiest de klant
     een maat die op voorraad is, dan gaat die meteen in het mandje. Sluit ze de lijst zonder te kiezen, dan gebeurt er niets.
   - Het maatveld op desktop rolt dezelfde lijst uit (nog een klik klapt hem weer in), maar voegt nog niets toe.
   - Staat de gewone knop op 'Houd me op de hoogte' (gekozen maat of hele product niet op voorraad), dan doet deze hetzelfde.
   - Tekst, prijs en kleuren komen van de gewone koopknop en de prijs op de pagina, en lopen mee als die veranderen.
   - Zolang de balk in beeld is, staat op <html> de class pip-satc-on en --pip-satc-h (hoogte), voor de chatknop. */
(function () {
  'use strict';
  var MQ = window.matchMedia('(max-width: 749px)');

  function q(sel, root) { return (root || document).querySelector(sel); }
  function txt(el) { return el ? String(el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function shown(el) { return !!(el && el.getClientRects().length); }

  function setup(bar) {
    if (!bar || bar.__pipSatc) return;
    /* de hoofdsectie van het product (Dawn: <product-info data-section>) met een koopknop */
    var sid = null, form = null;
    var infos = document.querySelectorAll('product-info[data-section]');
    for (var i = 0; i < infos.length && !form; i++) {
      var id = infos[i].getAttribute('data-section');
      var f = document.getElementById('product-form-' + id);
      if (f && f.closest('product-form')) { sid = id; form = f; }
    }
    var pf = form && form.closest('product-form');
    var sub = pf && pf.querySelector('.product-form__submit');
    if (!sub) return;
    bar.__pipSatc = true;
    var box = pf.querySelector('.product-form__buttons') || sub;

    var cfg = {};
    try { cfg = JSON.parse(q('[data-pip-satc-data]', bar).textContent) || {}; } catch (e) { cfg = {}; }

    /* los in de body zetten (niet binnen een vak met transform); een oude balk van een eerdere opbouw weghalen */
    document.querySelectorAll('body > [data-pip-satc]').forEach(function (old) { if (old !== bar) old.remove(); });
    document.body.appendChild(bar);

    var btn = q('[data-pip-satc-btn]', bar);
    var label = q('[data-pip-satc-label]', bar);
    var sep = q('[data-pip-satc-sep]', bar);
    var bprice = q('[data-pip-satc-btnprice]', bar);
    var sizeBtn = q('[data-pip-satc-size]', bar);
    var sizeWrap = q('[data-pip-satc-sizewrap]', bar);
    var dropEl = q('[data-pip-satc-drop]', bar);
    var sizeLabel = q('[data-pip-satc-size-label]', bar);
    var priceEl = q('[data-pip-satc-price]', bar);
    var cmpEl = q('[data-pip-satc-compare]', bar);
    var visible = null;
    var pending = false;   /* knop ingedrukt zonder maat: na de keuze meteen toevoegen */
    var waiting = false;   /* wachten tot de pagina de gekozen maat heeft verwerkt */

    function mkRoot() { return document.querySelector('[data-pip-mk][data-section="' + sid + '"]'); }
    function hasPicker() { return !!(mkRoot() && window.pipMk && window.pipMk.open); }
    function chosen() { return hasPicker() && window.pipMk.chosen ? window.pipMk.chosen(sid) : null; }
    function notifyMode() { return pf.classList.contains('pip-mk-soldout'); }
    function isOpen() { return !!(window.pipMk && window.pipMk.isOpen && window.pipMk.isOpen(sid)); }
    function closeList() { if (isOpen() && window.pipMk.close) window.pipMk.close(sid); }
    function busy() { return sub.disabled || sub.hasAttribute('disabled') || sub.getAttribute('aria-disabled') === 'true' || sub.classList.contains('loading'); }

    /* kleuren en letter van de gewone koopknop (zoals de knop in de maatlade) */
    function look() {
      var cs = window.getComputedStyle(sub);
      var bg = cs.backgroundColor;
      if (bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)') bar.style.setProperty('--pip-satc-bg', bg);
      if (cs.color) bar.style.setProperty('--pip-satc-fg', cs.color);
      if (cs.fontSize) bar.style.setProperty('--pip-satc-fs', cs.fontSize);
      if (cs.letterSpacing && cs.letterSpacing !== 'normal') bar.style.setProperty('--pip-satc-ls', cs.letterSpacing);
    }

    function pagePrice() {
      var p = document.getElementById('price-' + sid);
      if (!p) return { now: '', was: '' };
      var sale = p.querySelector('.price--on-sale');
      if (sale) {
        return { now: txt(sale.querySelector('.price__sale .price-item--sale')), was: txt(sale.querySelector('.price__sale s.price-item--regular')) };
      }
      return { now: txt(p.querySelector('.price__regular span.price-item--regular') || p.querySelector('.price-item--regular')), was: '' };
    }

    function sync() {
      var notify = notifyMode();
      var nb = pf.querySelector('.pip-mk-notify');
      var off = !notify && (sub.disabled || sub.hasAttribute('disabled'));
      var main = txt(sub.querySelector('span')) || txt(sub);
      label.textContent = notify ? (txt(nb) || cfg.notify || '') : (main || cfg.add || '');
      btn.classList.toggle('is-notify', notify);
      var busyNow = !notify && (sub.classList.contains('loading') || waiting);
      btn.classList.toggle('is-loading', busyNow);
      /* tijdens het toevoegen niet uitschakelen, anders raakt de knop de focus kwijt */
      btn.disabled = off && !busyNow;
      var pr = pagePrice();
      if (priceEl && pr.now) priceEl.textContent = pr.now;
      if (cmpEl) { cmpEl.textContent = pr.was; cmpEl.hidden = !pr.was; }
      if (bprice) {
        if (pr.now) bprice.textContent = pr.now;
        var hidePrice = notify || off || !pr.now;
        bprice.hidden = hidePrice;
        if (sep) sep.hidden = hidePrice;
      }
      if (sizeBtn) {
        if (!hasPicker()) { (sizeWrap || sizeBtn).hidden = true; return; }
        var c = chosen();
        sizeLabel.textContent = c != null ? (cfg.sizeWord || 'Maat') + ' ' + c : (cfg.placeholder || 'Kies je maat');
      }
    }
    var syncT = null;
    function later() { if (!syncT) syncT = setTimeout(function () { syncT = null; sync(); }, 30); }

    /* ---------- in en uit beeld ---------- */

    function update(force) {
      ticking = false;
      var r = box.getBoundingClientRect();
      var show = shown(box) && r.bottom < 0;
      if (show === visible && !force) return;
      visible = show;
      if (!show) closeList(); /* de balk gaat weg: een uitgerolde lijst gaat mee dicht */
      bar.classList.toggle('is-visible', show);
      if (show) { bar.removeAttribute('inert'); bar.removeAttribute('aria-hidden'); }
      else { bar.setAttribute('inert', ''); bar.setAttribute('aria-hidden', 'true'); }
      var h = show ? bar.offsetHeight : 0;
      document.documentElement.style.setProperty('--pip-satc-h', h + 'px');
      document.documentElement.classList.toggle('pip-satc-on', show && h > 0);
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      if (window.requestAnimationFrame && !document.hidden) window.requestAnimationFrame(function () { update(false); });
      else setTimeout(function () { update(false); }, 30);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { look(); update(true); }, { passive: true });

    /* ---------- toevoegen ---------- */

    function addNow() {
      var tries = 0;
      (function go() {
        if (notifyMode()) { waiting = false; sync(); return; }
        if ((waiting || busy()) && tries++ < 50) { setTimeout(go, 100); return; }
        waiting = false;
        sync();
        if (!busy()) sub.click();
      })();
    }

    /* na een maatkeuze past de pagina de variant aan (Dawn haalt de sectie opnieuw op); pas daarna toevoegen */
    function waitForVariant() {
      waiting = true;
      sync();
      var idInput = form.querySelector('input[name="id"]');
      var done = function () { waiting = false; if (idInput) idInput.removeEventListener('change', done); };
      if (idInput) idInput.addEventListener('change', done);
      setTimeout(done, 3000);
    }

    /* desktop: de lijst rolt uit boven het maatveld in de balk. Mobiel (of als de balk geen maatveld heeft): de lade of popup */
    function openList(opts) {
      var d = (!MQ.matches && dropEl && sizeWrap && shown(sizeWrap)) ? dropEl : null;
      opts.drop = d;
      opts.modal = !MQ.matches && !d;
      /* meteen openen; de maatkiezer telt een klik op de knop die de lijst opende niet als klik buiten de lijst */
      if (d) { window.pipMk.open(sid, opts); return; }
      /* lade en popup: na deze klik openen, zoals getest in groep 16 */
      setTimeout(function () { window.pipMk.open(sid, opts); }, 0);
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      if (notifyMode()) {
        if (hasPicker()) {
          pending = false;
          if (isOpen()) { closeList(); return; }
          openList({ notify: true, opener: btn });
          return;
        }
        var nb = pf.querySelector('.pip-mk-notify');
        if (nb) nb.click();
        return;
      }
      if (hasPicker() && chosen() == null) {
        /* staat de lijst al open (via het maatveld), dan blijft hij open met de regel erboven */
        pending = true;
        openList({ opener: btn, hint: cfg.hint || '' });
        return;
      }
      closeList();
      addNow();
    });

    if (sizeBtn) sizeBtn.addEventListener('click', function (e) {
      e.preventDefault();
      if (!hasPicker()) return;
      pending = false;
      if (isOpen()) { closeList(); return; } /* nog een klik op het veld klapt de lijst weer in */
      openList({ opener: sizeBtn });
    });

    document.addEventListener('pip:mk-chosen', function (e) {
      var d = e.detail || {};
      if (d.sid !== sid) return;
      later();
      if (!pending) return;
      pending = false;
      waitForVariant();
      addNow();
    });
    document.addEventListener('pip:mk-closed', function (e) {
      var d = e.detail || {};
      if (d.sid && d.sid !== sid) return;
      pending = false;
      later();
    });

    /* tekst, prijs en status van de gewone knop volgen */
    if ('MutationObserver' in window) {
      new MutationObserver(later).observe(pf, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['class', 'disabled', 'aria-disabled'] });
      var priceBox = document.getElementById('price-' + sid);
      if (priceBox) new MutationObserver(later).observe(priceBox, { subtree: true, childList: true, characterData: true });
      var mk = mkRoot();
      if (mk) new MutationObserver(later).observe(mk, { subtree: true, childList: true, characterData: true });
    }
    document.addEventListener('change', later);

    look();
    sync();
    update(true);
  }

  function initAll() { document.querySelectorAll('[data-pip-satc]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  window.addEventListener('load', initAll);
})();
